<div class="px-16 py-12 border-bottom border-gray-200"
    [style.background]="isTimerOnThisTask ? 'rgb(255, 251, 235)' : '#fff'"
    style="transition: background 0.2s;">
    <div class="d-flex align-items-center justify-content-between mb-8">
        <div class="d-flex align-items-center gap-1-5">
            <lucide-icon name="clock" [size]="15" [ngClass]="isTimerOnThisTask ? 'text-amber-500' : 'text-gray-500'" [strokeWidth]="2" class="flex-shrink-0"></lucide-icon>
            <!-- Section heading, matching Contact and History in the same panel — see .tts-section-label. -->
            <span class="tts-section-label">Time</span>
            <ng-container *ngIf="hasEntries">
                <span class="f-size-13 text-gray-300" style="line-height: 1; margin: 0 2px;">&middot;</span>
                <!-- The running total is a VALUE, so it keeps the lighter treatment the heading drops. -->
                <span class="f-size-13 text-gray-600">{{ totalTime }}</span>
            </ng-container>
        </div>
        <button *ngIf="hasEntries" type="button"
            class="btn d-flex align-items-center gap-04 px-06 py-02 f-size-12 text-gray-500 hover:bg-gray-100 rounded-sm transition-colors"
            (click)="onSeeAll(); $event.stopPropagation()">
            <span>See all</span>
            <lucide-icon name="chevron-right" [size]="14" [strokeWidth]="2"></lucide-icon>
        </button>
    </div>

    <!-- Active timer row -->
    <div *ngIf="isTimerOnThisTask"
        class="d-flex align-items-center justify-content-between rounded-sm"
        style="padding: 8px 10px; background: rgb(254, 243, 199); border: 1px solid rgb(253, 230, 138);">
        <div class="d-flex align-items-center gap-8">
            <span class="vf-time-dot flex-shrink-0"></span>
            <lucide-icon name="pause" [size]="14" [strokeWidth]="2" class="text-amber-600 flex-shrink-0"></lucide-icon>
            <span class="f-size-12 text-amber-700">Tracking</span>
            <span class="f-size-12 text-amber-800" style="font-variant-numeric: tabular-nums; font-family: ui-monospace, 'SF Mono', SFMono-Regular, Menlo, Monaco, Consolas, monospace;">{{ elapsed }}</span>
        </div>
        <button type="button"
            class="btn d-flex align-items-center gap-4 f-size-12 text-white rounded-sm border-0 transition-colors"
            style="padding: 2px 8px; background: #111827;"
            onmouseover="this.style.background='#374151'"
            onmouseout="this.style.background='#111827'"
            (click)="stopTimer()"
            [disabled]="isStopping">
            <lucide-icon name="square" [size]="10" [strokeWidth]="2" class="fill-white"></lucide-icon>
            <span>Stop</span>
        </button>
    </div>

    <!-- Start timer button -->
    <button *ngIf="!isTimerOnThisTask" type="button"
        class="btn w-100 d-flex align-items-center justify-content-center gap-1-5 f-size-12 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-sm transition-colors"
        style="padding: 6px 12px;"
        (click)="startTimer()">
        <lucide-icon name="play" [size]="14" [strokeWidth]="2"></lucide-icon>
        <span>Start timer</span>
    </button>
</div>
